import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { AnimatedOutlet } from "./AnimatedOutlet";
import { NotificationPanel } from "../widgets/NotificationPanel";
import { LicensingBanner } from "../common/LicensingBanner";
import { isEmeisSubscriptionEnabled } from "../../utils/emeisModuleFlags";
import { AiAssistantDock } from "../ai/AiAssistantDock";
import { AppFooter } from "./AppFooter";

export function AppShell() {
  return (
    <div className="w-screen h-screen bg-[rgb(var(--bg))] text-[rgb(var(--fg))] overflow-hidden">
      {/* Full-width Topbar */}
      <Topbar />
      {/*<PageHeader />*/}
      {/* Body */}
      <div className="flex h-[calc(100vh-56px)]">
        <Sidebar />

        <div className="flex-1 flex flex-col min-w-0">
          {/*<Breadcrumbs />*/}
          {/* Plan-expiry banner: internal "isEmeisSubscription" switch only for now. */}
          {isEmeisSubscriptionEnabled() && <LicensingBanner />}
          <main
            className="flex-1 overflow-auto px-3 py-4 sm:px-4 md:px-6 overflow-y-auto overflow-x-visible"
          >
            <div className="w-full max-w-[1600px] mx-auto">
              <AnimatedOutlet />
            </div>
          </main>
          <AppFooter />
        </div>
      </div>

      <NotificationPanel />
      {/* lawyal.ai: internal switches only for now. The chat button floating
          at the corner follows "enableEmeisAI"; see AiAssistantDock. */}
      <AiAssistantDock />
    </div>
  );
}
